import styled from 'styled-components';

export const TableInnerWrapper = styled.div`
  margin-bottom: 20px;
  position: relative;
  :last-child{
    margin-bottom: 0;
  } 
`;

export const BottomGradient = styled.div`
  width: 100%;
  height: 120px;
  position: absolute;
  bottom: 0px;
  background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,${props => props.theme.colors.colorShadow} 38%,${props => props.theme.colors.mainColor} 87%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#f0fde9eb',GradientType=0 );
`;



// WEBPACK FOOTER //
// ./src/components/DynamicTable/styles.js